import { memo } from 'react';
import {
  setComma,
  classNameBind,
} from '@wconcept/wconcept-common/utils/commonUtils';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import Tag from '@wconcept/wconcept-ui-renewal/components/atoms/Tag';
import { IconArrowRight05 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg/index';
import {
  DepthCate,
  DepthCate1,
  DepthCate2,
} from '@wconcept/wconcept-ui-renewal/@types/search';
import * as S from './style';

interface IProps {
  depth1?: DepthCate1;
  depth2?: DepthCate2;
  depth3?: DepthCate;
  cnt?: number;
  onClick?: () => void;
}

const FltRecCategoryItem = ({
  depth1,
  depth2,
  depth3,
  cnt,
  onClick,
}: IProps) => {
  const cName = classNameBind(['filter-rec-category item']);

  return (
    <S.FltRecCategoryItem className={cName}>
      <Button onClick={onClick}>
        <Tag>추천</Tag>
        <Text>{depth1?.name}</Text>
        {depth2 && (
          <Text className="text02">
            <em>
              <IconArrowRight05 />
            </em>
            {depth2.name}
          </Text>
        )}
        {depth2 && depth3 && (
          <Text>
            <em>
              <IconArrowRight05 />
            </em>
            {depth3?.name}
          </Text>
        )}
        {cnt && <Text className="cnt">{setComma(String(cnt))}</Text>}
      </Button>
    </S.FltRecCategoryItem>
  );
};

export default memo(FltRecCategoryItem);
